<template>
  <section v-if="showPage">
    <div class="viewsrhwxEvaluate_CheckIn">
      <div class="warn">
        请确认本次篷布防护的服务质量：
      </div>
      <div class="cont2">
        <van-cell
          title="由谁做篷布防护"
          is-link
          arrow-direction="down"
          :value="value"
          @click="show = true"
        />
        <van-action-sheet
          v-model="show"
          :actions="actions"
          cancel-text="取消"
          close-on-click-action
          @cancel="onCancel"
          @select="onselect"
        />
      </div>
      <div v-if="params.type === 2" class="cont3">
        <div class="title">自行做篷布防护的原因</div>
        <van-field
          v-model="params.reason"
          rows="4"
          type="textarea"
          placeholder="请输入原因"
        />
      </div>
      <div v-if="params.type === 1" class="cont3">
        <div class="title">请对篷布防护服务评分</div>
        <div class="rateDiv">
          <van-rate
            v-model="params.rate"
            :size="25"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
          />
          <span class="text">{{ rateText[Number(params.rate) - 1] }}</span>
        </div>
      </div>
      <div class="cont5">
        <!-- <div class="title">请对篷布防护服务评分</div> -->
        <div class="checkbox">
          <van-checkbox v-model="params.checked"
            >我郑重承诺已经完成篷布防护作业，如有不实愿承担安全责任。</van-checkbox
          >
        </div>
      </div>
      <div class="cont6">
        <div class="title">意见反馈（选填）</div>
        <div class="rateDiv">
          <van-field
            v-model="params.remark"
            rows="4"
            type="textarea"
            placeholder="这是选填栏目，如有意见，欢迎填写"
          />
        </div>
      </div>
      <div style="height: 86px;background-color: #f4f5f6;"></div>
      <div class="cont4">
        <van-button type="primary" block class="btnStyle1" @click="saveSignIn"
          >提交</van-button
        >
      </div>
    </div>
  </section>
</template>

<script>
// import { Dialog, Toast } from "vant";
export default {
  components: {},
  data() {
    return {
      show: false,
      actions: [
        { name: "现场工作人员", val: 1 },
        { name: "自己做的", val: 2 }
      ],
      rateText: ["非常不满意", "不满意", "一般", "满意", "非常满意"],
      params: {
        type: "",
        reason: "",
        rate: 0,
        checked: false,
        remark: ""
      },
      value: "请选择",
      showPage: true
    };
  },
  beforeRouteUpdate() {},
  methods: {
    onCancel() {
      this.show = false;
    },
    onselect(item) {
      console.log(item);
      this.params.type = item.val;
      this.value = item.name;
    },
    async saveSignIn() {
      //   if (this.licenseValue.trim() === "") {
      //     this.$common.mbToastFail("车牌号不能为空");
      //     return false;
      //   }
      //   if (
      //     (this.licenseValue.trim().length < 7 &&
      //       this.licenseType === "normal") ||
      //     (this.licenseValue.trim().length < 8 &&
      //       this.licenseType === "newEnergy") ||
      //     (this.licenseValue.trim().length < 7 &&
      //       this.licenseType === "HKorMacao")
      //   ) {
      //     this.$common.mbToastFail("请完善车牌号");
      //     return false;
      //   }
      //   if (this.params.name.trim() === "") {
      //     this.$common.mbToastFail("司机真实姓名不能为空");
      //     return false;
      //   }

      if (this.params.type === "") {
        this.$common.mbToastFail("请选择“由谁做的篷布防护”！");
        return;
      }

      if (this.params.type === 2 && this.params.reason.trim().length == 0) {
        this.$common.mbToastFail("请填写“自行做篷布防护的原因”！");
        return;
      }

      if (this.params.type === 1 && this.params.rate === 0) {
        this.$common.mbToastFail("请对篷布防护服务作出评分！");
        return;
      }

      if (this.params.checked === false) {
        this.$common.mbToastFail("请勾选安全承诺后再提交！");
        return;
      }

      if (this.params.type === 1) {
        this.params.reason = "";
      }

      if (this.params.type === 2) {
        this.params.rate = 0;
      }

      let report_id = this.$route.query.report_id;
      let data = {
        operator_type: this.params.type,
        self_reason: this.params.reason,
        score: this.params.rate,
        complete_operation: this.params.checked ? 1 : 0,
        feedback: this.params.remark,
        report_id,
        sub_com_id: this.$route.query.sub_com_id
      };
      await this.$common.http({
        url: "/api/queue/driver/submit_tarpaulin_comment",
        data: data
      });
      this.$router.push({
        path: "/rhwxEvaluateResult",
        query: {
          map_type: this.$route.query.map_type,
          com_id: this.$route.query.com_id,
          sub_com_id: this.$route.query.sub_com_id
        }
      });
    }
  },

  created() {
    let report_id = this.$route.query.report_id;
    if (report_id) {
      this.$common
        .http({
          url: "/api/queue/driver/pre_operate_info",
          data: {
            report_id,
            sub_com_id: this.$route.query.sub_com_id
          }
        })
        .then(res => {
          console.log(res);
          let data = res.data.data;
          if (Number(data.have_comfirm_tarpaulin) === 1) {
            this.$router.push({
              path: "/rhwxEvaluateResult",
              query: {
                app_id: this.$route.query.app_id,
                com_id: this.$route.query.com_id,
                map_type: this.$route.query.map_type,
                sub_com_id: this.$route.query.sub_com_id
              }
            });
          } else if (Number(data.info_tarpaulin_status) === 1) {
            this.showPage = true;
          }
        });
    } else {
      this.showPage = true;
    }
  }
};
</script>
<style lang="less">
@import "../assets/css/common";
.viewsrhwxEvaluate_CheckIn {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;
  .warn {
    background: #f4f5f6;
    font-size: 17px;
    color: #ec3f67;
    padding: 16px 16px 6px 16px;
  }
  .cont2 {
    margin: 10px 0px;
    background: #fff;
    .van-field__label {
      width: 120px;
    }
    .van-cell__title {
      font-size: 16px;
      color: #000000;
    }
    .van-cell {
      padding: 20px 16px;
    }
  }
  .cont3 {
    margin: 10px 0px;
    background: #fff;
    padding: 10px 16px 15px 16px;
    font-size: 17px;
    .title {
      padding: 10px 0px 15px 0;
    }
    .title::after {
      position: absolute;
      color: #ee0a24;
      font-size: 16px;
      content: "*";
    }
    .closebtn {
      vertical-align: top;
      font-size: 22px;
      opacity: 0.5;
      z-index: 10;
      position: relative;
      text-align: right;
      border-radius: 50%;
    }
    .list {
      background: #f6f6f7;
      border-radius: 5px;
      margin-top: -20px;
    }
    .addbtn {
      display: flex;
      align-items: center;
      margin: 18px 0px 13px 0px;
      &-span {
        color: #009967;
        margin-left: 7px;
      }
    }
    .van-cell {
      padding: 0;
    }
    .rateDiv {
      display: flex;
      align-items: center;
      padding-bottom: 8px;
      .van-rate__item:not(:last-child) {
        padding-right: 26px;
      }
      .text {
        padding-left: 26px;
        font-size: 14px;
        color: #666666;
        padding-top: 2px;
      }
    }
  }

  .cont4 {
    // padding: 29px 15px;
    // background: #f4f5f6;
    bottom: 0px;
    width: 90%;
    position: fixed;
    background: #f4f5f6;
    padding: 15px 5%;
    z-index: 11;
  }

  .cont5 {
    margin: 10px 0px 0px 0px;
    padding: 0 16px 0 16px;
    .checkbox {
      padding: 10px 0px 8px;
    }
    .van-checkbox__label {
      color: #009967;
      font-size: 14px;
    }
    .van-checkbox__icon--checked .van-icon {
      color: #fff;
      background-color: #009967;
      border-color: #009967;
    }
  }

  .cont6 {
    margin: 10px 0px;
    background: #fff;
    padding: 10px 16px;
    .title {
      padding: 10px 0px 12px 0px;
      font-size: 16px;
      color: #666666;
    }
    .van-cell {
      padding: 0;
    }
  }
}

.van-cell::after {
  border-bottom: none;
}
.van-field__label {
  color: #000;
  margin-right: 23px;
}
.van-dialog__message {
  font-size: 16px;
}
.van-cell__title {
  span {
    position: relative;
  }
  span::after {
    position: absolute;
    color: #ee0a24;
    font-size: 16px;
    content: "*";
  }
}
</style>
